import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { DropdownField } from '@nextiva/engagement-ui';
import QuestionErrorMessage from './questions/QuestionErrorMessage';

export default class FormDropdownField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    multi: PropTypes.bool,
    meta: PropTypes.shape({
      error: PropTypes.string,
      submitFailed: PropTypes.bool,
    }),
    isErrorMessageSupported: PropTypes.bool,
    containerClassName: PropTypes.string,
  };

  static parseOptionValue = option => {
    if (isNil(option)) {
      return option;
    }
    return Array.isArray(option)
      ? option.map(item => item.value)
      : option.value;
  };

  static defaultProps = {
    isErrorMessageSupported: true,
  };

  render() {
    const {
      input,
      meta,
      meta: { error, submitFailed },
      isErrorMessageSupported,
      containerClassName,
      ...props
    } = this.props;

    return (
      <div className={containerClassName}>
        {isErrorMessageSupported && <QuestionErrorMessage fieldMeta={meta} />}
        <DropdownField
          {...input}
          {...props}
          isErrorMessageSupported={isErrorMessageSupported}
          isError={error && submitFailed}
          errorText={error}
        />
      </div>
    );
  }
}
